import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import { createUseStyles } from 'react-jss';

/** Overrides Modal wrapper max-width (library sets its own on the same node). */
const styles = {
  modal: {
    maxWidth: '90rem',

    [breakpoints.lg.down]: {
      maxWidth: '65%',
    },

    [breakpoints.md.down]: {
      maxWidth: '80%',
    },
  },
};

const createEditPrimaryModalStyles = createUseStyles(styles);

export { createEditPrimaryModalStyles };
